import { render, staticRenderFns } from "./StudentHistoryDialog.vue?vue&type=template&id=57e184fc&scoped=true"
import script from "./StudentHistoryDialog.vue?vue&type=script&lang=js"
export * from "./StudentHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentHistoryDialog.vue?vue&type=style&index=0&id=57e184fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e184fc",
  null
  
)

export default component.exports